import { BASE_URL } from '@/lib/axios'

/**
 * Safely constructs a full media URL.
 * Prevents double prefixing if the path is already absolute.
 * @param path The file path or full URL
 * @returns The full URL to the media asset
 */
export const getMediaUrl = (path: string | undefined | null) => {
    if (!path) return ''

    let processedUrl = path.replace(/\\/g, '/')

    // 1. Remove non-printable/corrupted characters
    processedUrl = processedUrl.replace(/[^\x21-\x7E\u00C0-\u017F]/g, '')

    // 2. Handle absolute URLs and old domains
    // If it's an absolute URL, check if it contains /uploads/
    if (processedUrl.includes('/uploads/')) {
        const uploadsIndex = processedUrl.indexOf('/uploads/')
        processedUrl = processedUrl.substring(uploadsIndex)
    } else if (processedUrl.startsWith('uploads/')) {
        processedUrl = '/' + processedUrl
    }

    // 3. Strip old /skg/ prefix if present
    if (processedUrl.startsWith('/skg/')) {
        processedUrl = processedUrl.substring(4)
    }

    // If it's still an absolute URL that's NOT our current uploads path, return as is
    if (processedUrl.startsWith('http') && !processedUrl.includes('/uploads/')) {
        // Recovery logic for double http
        if (processedUrl.includes('http', 4)) {
            const parts = processedUrl.split('http')
            const lastPart = parts[parts.length - 1]
            return `http${lastPart}`
        }
        return processedUrl
    }

    // Ensure leading slash for relative paths
    let sanitizedUrl = processedUrl
    if (!sanitizedUrl.startsWith('/') && !sanitizedUrl.startsWith('http')) {
        sanitizedUrl = '/' + sanitizedUrl
    }

    // Handle potential double slashes
    sanitizedUrl = sanitizedUrl.replace(/\/+/g, '/')

    // Remove trailing slash from BASE_URL if it exists to avoid //
    const cleanBaseUrl = BASE_URL.endsWith('/') ? BASE_URL.slice(0, -1) : BASE_URL

    // If it's already absolute (e.g. from /uploads/), prefix with BASE_URL
    if (sanitizedUrl.startsWith('/')) {
        return `${cleanBaseUrl}${sanitizedUrl}`
    }

    return sanitizedUrl
}
